<template>
  <a-modal
    style="z-index: 999;"
    title="续费"
    :visible="visible"
    ok-text="确认续费"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p>续费方案：</p>
    <div v-if="orderPrdData">
      <div class="cus-radio-group">
        <div
          class="cus-radio"
          :class="{'active': index === activeIndex}"
          v-for="(item, index) in orderPrdData"
          :key="index"
          @click="handleChange(item, index)"
        >
          ￥{{ item.value }} <br />
          {{ item.id === 'NORMAL'? '买码会员1年' : '无限码会员1年' }}
        </div>
      </div>
      <!--      <a-button style="width: 130px;height:80px;margin-right: 20px;" v-for="item in orderPrdData" :key="item.id" @click="handleChange(item)">-->
      <!--        <p>￥ {{ item.value }}</p>-->
      <!--        <p>{{ item.id === 'FOREVER'? '无限码会员': '买码会员' }}1年</p>-->
      <!--      </a-button>-->
    </div>
    <p style="margin: 20px 0;">说明：若从买码会员续费无限码会员，则原本账户剩余防伪码清零，无限码会员即时生效；若从无限码会员续费为买码会员，则无限码会员到期后自动切换为买码会员。</p>
    <!--    <p>订单号：{{ orderId }}</p>-->
    <!--    <p>交易内容：{{ orderType | valInDict(dict.orderTypeDict) }}</p>-->
    <div>
      <p style="margin-top: 40px;margin-right: 62px;">支付方式：
        <a-radio-group v-model="payType">
          <a-radio
            v-for="item in dict.payTypeDict"
            :key="item.id"
            :value="item.id"
          >
            <a-icon v-if="item.id === 'WEIXIN'" type="wechat" />
            <a-icon v-if="item.id === 'ALIPAY'" type="alipay-circle" />
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </p>
      <!--        <div v-for="item in dict.payTypeDict" :key="item.id">-->
      <!--          <a-button icon="wechat" :class="payType===item.id?'select':''" style="width: 89px;height: 89px;font-size: 60px;margin-right: 20px;" v-if="item.id === 'WEIXIN'" @click="postOrderPay('WEIXIN')"></a-button>-->
      <!--          <a-button icon="alipay" :class="payType===item.id?'select':''" style="width: 89px;height: 89px;font-size: 60px;" v-if="item.id === 'ALIPAY'" @click="postOrderPay('ALIPAY')"></a-button>-->
      <!--        </div>-->
    </div>
    <!--    <div class="money">{{ payType | valInDict(dict.payTypeDict) }}支付 <span class="red fw-b">￥{{ price }}</span> </div>-->
    <!--    <div>使用{{ payType | valInDict(dict.payTypeDict) }}扫一扫支付订单，若支付后未自动刷新，请手动点击【我已支付】刷新页面。若支付失败，可前往打印管理-打印订单重新支付</div>-->
    <a-modal :visible="codeModal" @ok="payOk" @cancel="payCancel">
      <div class="qrcode" v-if="payType === 'WEIXIN'">
        <a-spin v-if="!codeUrl" />
        <a-avatar
          v-if="codeUrl"
          :size="200"
          shape="square"
          :src="codeUrl"
          alt="支付二维码"
        />
        <a-button
          type="primary"
          shape="circle"
          class="fresh-qrcode-btn"
          icon="redo"
          @click="postOrderPay"
        />
      </div>
    </a-modal>
  </a-modal>
</template>

<script>
import { annualPay, queryPayResult, addAnnualOrder } from '@/api/tenant'

export default {
  data() {
    return {
      orderId: 0,
      tenant_id: 0,
      visible: false,
      confirmLoading: false,
      codeModal: false,
      payType: this.defaultPayType,
      dict: {
        payTypeDict: [{ id: 'WEIXIN', name: '微信' }, { id: 'ALIPAY', name: '支付宝' }],
        orderTypeDict: [
          { id: 'RECHARGE', name: '充值订单' },
          { id: 'PRINT', name: '打印订单' },
          { id: 'ANNUAL', name: '续费订单' }
        ]
      },
      codeUrl: '', // 二维码
      timer: null,
      activeIndex: '',
      type: ''
    }
  },
  props: {
    orderPrdData: {
      type: Array,
      default: function () {
        return {}
      }
    },
    // 支付方式（WEIXIN-微信扫码；ALIPAY-支付宝扫码）
    defaultPayType: {
      type: String,
      default: 'WEIXIN'
    },
    // 订单类型（RECHARGE-充值订单；PRINT-打印订单；ANNUAL-续费订单）
    orderType: {
      type: String,
      default: 'ANNUAL'
    },
    // 价格
    price: {
      type: [String, Number],
      default: 0
    }
  },
  watch: {
    defaultPayType(val) {
      this.payType = val
    }
  },
  mounted() {
  },
  methods: {
    payOk () {
      clearInterval(this.timer)
      this.timer = null
      this.codeModal = false
      this.visible = false
      this.$emit('close')
    },
    payCancel () {
      clearInterval(this.timer)
      this.timer = null
      this.codeModal = false
    },
    addOrder () {
      const params = {
        tenant_id: this.tenant_id,
        type: this.type,
        pay_type: 'WEIXIN'
      }
      addAnnualOrder(params)
        .then(res => {
          // this.orderId = res.data.orderId
          if (res.code === 200) {
            // this.getOrderPre()
            this.orderId = res.data.orderId
            this.postOrderPay()
          }
        })
    },
    showModal(tenantId) {
      this.visible = true
      this.tenant_id = tenantId
      setTimeout(() => {
        // this.postOrderPay()
      }, 0)
    },
    handleOk() {
      this.addOrder()
      this.confirmLoading = true
      if (this.payType === 'WEIXIN') {
        this.codeModal = true
      }
    },
    handleCancel() {
      this.visible = false
      clearInterval(this.timer)
      this.timer = null
      this.$emit('close')
    },
    // 获取支付订单二维码
    postOrderPay() {
      this.codeUrl = ''
      annualPay({
        order_type: 'ANNUAL',
        orderId: this.orderId,
        tenant_id: this.tenant_id,
        pay_type: this.payType,
        return_url: window.location.href
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (this.payType === 'ALIPAY') {
              const divForm = document.getElementsByTagName('divform')
              if (divForm.length) {
                document.body.removeChild(divForm[0])
              }
              const div = document.createElement('divform')
              div.innerHTML = data // data就是sb支付宝返回给你的form
              document.body.appendChild(div)
              document.getElementById('alipaysubmit').setAttribute('target', '_blank') // 加了_blank可能出问题所以我注释了
              document.getElementById('alipaysubmit').submit()
            } else {
              this.codeUrl = data.code_url
            }
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
              this.queryPayResult()
            }, 1000)
          }
        })
        .catch((e) => {
          this.$message.error('请求支付失败')
        })
    },
    handleChange (data, index) {
      this.activeIndex = index
      // this.price = data.value
      this.type = data.id
      // this.addOrder()
    },
    // 检查订单是否完成支付
    queryPayResult() {
      queryPayResult({
        tenant_id: this.tenant_id,
        order_type: 'ANNUAL',
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (data.pay === 'SUCCESS') {
              this.$message.success(res.message)
              this.handleOk()
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求订单是否完成支付失败')
        })
    }
  }
}
</script>
<style lang="less">
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 20px auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
.select {
  color: #48d2db;
  border: 1px solid #48d2db;
}
.cus-radio-group {
  display: flex;
  .cus-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 20px;
    border: 1px solid #eee;
    margin: 10px;
    flex: 1;
    &.active {
      border: 1px solid yellow;
      background: rgba(110, 110, 110, 0.5);
      box-shadow: 0 0 4px 2px #f7ff2cb8;
    }
  }
}
</style>
